An organization hiring for an open position.
